jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/accordion.js');

  loadMorePosts.init();
  loadMoreProjects.init();
  loadMoreProjectsTax.init();
});


function runOnHomePage() {
  if (window.location.href === window.location.origin + '/') {
		// Select all elements with the specified class
		var elements = document.getElementsByClassName('flex-columns');

		// Determine the index of the last element
		var lastIndex = elements.length - 1;

		// Add a class to the last element
		elements[lastIndex].classList.add('last-class');

		const colOne = document.querySelector('.last-class').children[0];
		const colTwo = document.querySelector('.last-class').children[1];

		if(colOne.classList.contains('flex-column-image') && colTwo.classList.contains('flex-column-image')) {
			colTwo.classList.add('disable-spining-logo');
		}

		if(colOne.classList.contains('flex-column-content') && colTwo.classList.contains('flex-column-image')) {
			colTwo.classList.add('spining-logo-left');
		}
  }
}

document.addEventListener('DOMContentLoaded', function() {
  runOnHomePage();
});


// Simple Parallax
var images = document.querySelectorAll('.column-banner img');
new simpleParallax(images, {
	scale: 1.5
});

var images2 = document.querySelectorAll('.flex-column-image img');
new simpleParallax(images2, {
	scale: 1.5
});


// Load More Posts
var loadMorePosts = {
	init: function() {
    jQuery('#load-more').click(function(){
      loadMorePosts.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-container');
		var postCount = jQuery('#load-container .post-thumbnail').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_posts',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,
			beforeSend: function () {

				// Request for posts

				jQuery('#load-more').addClass('loading');
			},
			complete: function () {

				// Request for posts received / response is being sent back to us

				jQuery('#load-more').removeClass('loading');
			},
			success: function(data) {

				// We get posts back / successful response

				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-container .post-thumbnail').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more').replaceWith('<a class="button load-button no-posts" href="#load-more-anchor">Back <span>To Top</span></a>');
				}

				return;
			}
		});
	}
}


// Load More Projects
var loadMoreProjects = {
	init: function() {
    jQuery('#load-more-projects').click(function(){
      loadMoreProjects.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-projects-container');
		var postCount = jQuery('#load-projects-container .project-thumbnail').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_projects',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,
			beforeSend: function () {

				// Request for posts

				jQuery('#load-more-projects').addClass('loading');
			},
			complete: function () {

				// Request for posts received / response is being sent back to us

				jQuery('#load-more-projects').removeClass('loading');
			},
			success: function(data) {

				// We get posts back / successful response

				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-projects-container .project-thumbnail').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more-projects').replaceWith('<a class="button load-button no-posts" href="#load-more-projects-anchor">Back <span>to top</span></a>');
				}

				return;
			}
		});
	}
}


// Load More Projects Taxonomy
var loadMoreProjectsTax = {
	init: function() {
    jQuery('#load-more-projects-tax').click(function(){
      loadMoreProjectsTax.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-projects-container-tax');
		var postCount = jQuery('#load-projects-container-tax .project-thumbnail').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_projects_tax',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,
			beforeSend: function () {

				// Request for posts

				jQuery('#load-more-projects-tax').addClass('loading');
			},
			complete: function () {

				// Request for posts received / response is being sent back to us

				jQuery('#load-more-projects-tax').removeClass('loading');
			},
			success: function(data) {

				// We get posts back / successful response

				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-projects-container-tax .project-thumbnail').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more-projects-tax').replaceWith('<a class="button load-button no-posts" href="#load-more-projects-anchor-tax">Back <span>to top</span></a>');
				}

				return;
			}
		});
	}
}